import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../services/auth.ts";
import TopNav, { AppNavMode } from "../components/TopNav.tsx";

const ChangePassword: React.FC = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleModeNav = (mode: AppNavMode) => {
    if (mode === "practice-exam") {
      navigate("/practice-exam");
      return;
    }
    navigate(`/questions?mode=${mode}`);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await changePassword(currentPassword, newPassword);
      setSuccess("Password changed successfully");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err: any) {
      setError(err.response?.data?.detail || "Could not change password");
    } finally {
      setLoading(false);
    }
  };

  const fieldClass =
    "rounded-lg px-4 py-3 text-xl font-body border border-border focus:border-accent focus:outline-none bg-white text-ink";
  const labelClass = "text-xl font-semibold mb-1 text-gray-500 font-body";

  return (
    <div className="min-h-screen">
      <TopNav activeMode="profile" onSelect={handleModeNav} />
      <div className="flex flex-col items-center px-6 py-16">
        <div className="bg-white rounded-lg border border-border p-8 w-full max-w-md flex flex-col items-center">
          <h2 className="text-5xl font-bold mb-6 text-ink font-display">Change Password</h2>
          <form onSubmit={handleSubmit} className="w-full flex flex-col gap-4">
            <div className="flex flex-col">
              <label className={labelClass}>Current password</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                autoComplete="current-password"
                className={fieldClass}
                placeholder="Current password"
              />
            </div>
            <div className="flex flex-col">
              <label className={labelClass}>New password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                autoComplete="new-password"
                className={fieldClass}
                placeholder="New password"
              />
            </div>
            <div className="flex flex-col">
              <label className={labelClass}>Confirm new password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                autoComplete="new-password"
                className={fieldClass}
                placeholder="Re-enter new password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="bg-primary text-white text-xl font-semibold font-body py-3 px-8 rounded-lg hover:bg-ink transition-colors duration-200 mt-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Changing..." : "Change password"}
            </button>
          </form>
          {success && <div className="mt-4 text-xl text-success font-semibold font-body text-center">{success}</div>}
          {error && <div className="mt-4 text-xl text-incorrect font-semibold font-body text-center">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
